export default {
  pcd: "40U",
  pname: "うまかけん福岡",
  header: "うまかけん福岡食事券抽選申込",
  explanation: "本サイトは、うまかけん福岡食事券の申込受付サイトです。\n申込方法をご案内しますので、\n以下同意したうえでメールアドレスのご登録をお願いいたします。",
  personalinfo: "ご入力いただきました個人情報は、食事券の販売のために使用いたします。\n個人情報は、法令に基づく場合を除き、ご本人様の承諾なしに第三者（弊社業務委託先を除く）に提供することはありません。",
  cid: "umakaken",
  unitdetails: "10,000円（1,000円×10枚）／1セット",
  ticketvalue: 10000,
  unitprice: 8000,
  maxunits: 2,
  quantityoptions: [
      {value: "1", text: "1"},
      {value: "2", text: "2"}
  ],
  emaillead: "1メールアドレスあたり1回のみのお申し込みになります。",
  starttime: "10:00",
  sentmsg: {
    header: "メールアドレスのご登録",
    body: {
        lines: [
            "ご登録されたメールアドレスに、抽選申込URLを送信しました。",
            "現時点では抽選申込は完了しておりません。",
            "ご案内メールの抽選申込URLより申込み手続きを行ってください。",
            "※メールを削除または紛失した場合は、再度受付サイトにてメールアドレスの登録手続きを行ってください。"
        ]
    },
    mailnotice: {
        header: "メールが届かない場合は以下をご確認ください。",
        items:[
           "迷惑メールボックスやごみ箱フォルダに入っていないかご確認ください。",
           "上記をご確認いただき、申込完了通知が届いていない場合は、「funity-rs.jp」からメールを受信出来るように設定のうえ、再度受付サイトにてメールアドレスの登録から、手続きを行ってください。"
        ]
    }
},
  applypageheader: "食事券の抽選申込み｜応募申込情報入力",
  confirmpageheader: "食事券の抽選申込み｜応募申込情報確認",
  acceptbtn: "承諾して応募申込",
  startdatenotice: {
      title: "抽選受付に関して",
      header: "うまかけん福岡食事券の抽選受付に関して、以下を確認の上、抽選応募申込を完了してください。",
      alert: "",
      body: "",
      danger: "",
      help: "",
      descriptions: [
          {
              term:"1. 抽選方式について",
              definition: [
                  {text:"Web 受付にて、システムによる抽選を実施いたします。"}
              ]
          },
          {
              term:"2. 当選結果の通知について",
              definition: [
                  {text: "抽選結果はメールにて配信されます\n配信日：2023年2月1日（水）10:00\n通知方法：メール配信のみ"},
                  {text: "※当選通知メールにはファミリーマートにて食事券が発券できる引換票番号が書かれています。"}
              ],
          },
          {
              term:"3. 食事券をファミリーマートにて支払・発券",
              definition:[
                  {text: "当選通知に記載されている引換期限までにファミリーマート店舗で引き換えてください。\n"},
                  {text: "支払・発券期間：当選通知に記載\n"},
                  {text: "発券場所：全国のファミリーマート店内のマルチコピー機にて発券\n※引換開始日は混雑が予想されます。引換期限はゆとりをもたせていますので、慌てずに引換えてください。\n※一部 マルチコピー機端末が設置していない店舗もございます。"}
              ]
          },
          {
            term:"4. 食事券に関する注意事項",
            definition:[
              {text: "・本食事券ご利用時つり銭は出ません。券面額を上回るご利用は、現金と併用してご利用ください。\n"},
              {text: "・本食事券購入後の変更・払戻しは一切できません。\n"},
              {text: "・期間を経過した食事券は無効となります。\n"},
              {text: "・福岡県内の加盟店でご利用いただけます。加盟店は予告なく更新されます。\n"},
              {text: "・加盟店はうまかけん福岡事務局ホームページより確認できます。\n"},
              {text: "・飲食店の予約やお問い合わせは、お客様ご自身にてお願いいたします。\n"},
              {text: "・紛失・盗難・滅失並びに利用期間の経過によるチケットの無効化に対して、発行者・事務局は責任を負いません。\n"},
              {text: "・コピー、模造、偽造は禁止されています。\n"},
              {text: "・切り離し無効\n"},
              {text: "・本食事券の転売、第3者への転売目的とする譲渡は禁止します。\n"},
              {text: "・本食事券は加盟店の事業上の取引（仕入等）への使用はできません。\n"},
              {text: "・本食事券の現金との交換不可。\n"},
              {text: "・本食事券の予約時に発行する払込票番号の転売は禁止されています。\n"},
              {text: "・本食事券の転売によって入手された払込票番号の利用はできません。\n"},
              {text: "・新型コロナウイルス等の感染状況によっては、ご利用を控えるようお願いする場合がございます。\n\n"}
            ]
        }, 
        {
          term:"【お客様お問い合わせコールセンター】",
        definition:[
          {text:"「うまかけん福岡」事務局\n"},
          {text: "0570-057-207（平日10:00～17:00 ※土日祝日除く）\n"},
        ]
    }
      ],
      footer: ""
  },
  completemsg: {
      header: "食事券の抽選申込み｜抽選申込完了",
      body: {
          paragraphs: [
              {parts:[{text: "抽選申込みを受付しました。"}]},
              {parts:[{text: "ご登録されたメールアドレスに、抽選申込完了通知を送信しました。"}]},
              {parts:[
                  {text: "当選通知メール配信日\nご登録のメールアドレスに下記日時にて順次配信を致します。\n"},
                  {text: "2023年2月1日（水）10:00から順次配信開始\n\n"},
                  {text: "※funity-rs.jp より、メールを配信いたします。\n"},
                  {text: "以下の設定方法をご確認頂き、「funity-rs.jp」からメールを受信出来るように設定をお願い致します。\n"},
                  {text: "※迷惑メールフォルダに振り分けられている可能性もございますので、ご確認ください。\n"},
              ]},
              {parts:[{text: "食事券のお受け取りには、当選通知メールに記載の引換票番号が必要になります。\nメールに記載の入金発券期間にて、ファミリーマートでお支払い、食事券のお受け取りをお願いいたします。"}]},
          ]
      },
      mailnotice: {
          header: "",
          items:[
          ]
      },
      footer: {
          paragraphs: [
              {parts:[]}
          ]
      }
  },
  lottery: true,
};
